import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RcFile } from 'antd/es/upload';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  createCustomerAttachmentThunk,
  deleteMultipleCustomerAttachmentThunk,
  getCustomerAttachments,
} from '../../../../../store/thunks/customers/customersAttachmentsThunks';
import {
  customerAttachmentsFiltersSelector,
  customerAttachmentsSelector,
} from '../../../../../store/selectors/customersSelectors';
import CustomerAttachFilters from './CustomerAttachFilters';
import CreateAttachmentModal from '../../../../../common/components/create-attachment/CreateAttachmentModal';
import { setLoading } from '../../../../../store/slices/coreSlice';
import CustomerAttachTable from './CustomerAttachTable';
import ConfirmationModal from '../../../../../core/components/confirmation-modal/ConfirmationModal';
import { guidGenerator } from '../../../../../core/utils/guidGenerator';
import { useSelectAll } from '../../../../../core/hooks/useSelectAll';

const CustomerAttachments: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { items, allItemIds, totalCount } = useAppSelector(customerAttachmentsSelector);
  const filters = useAppSelector(customerAttachmentsFiltersSelector);

  const [isCreateModal, setCreateModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [comment, setComment] = useState('');

  const cancelHandle = () => {
    setCreateModal(false);
    setFileList([]);
    setComment('');
  };

  const {
    isAll,
    isIndeterminate,
    checkedKeys,
    checkAllHandle,
    checkRowHandle,
  } = useSelectAll(allItemIds);

  useEffect(() => {
    id && dispatch(getCustomerAttachments({ customerId: +id, filters: { ...filters } }));
    // eslint-disable-next-line
  }, [id, filters]);

  const uploadHandle = async () => {
    dispatch(setLoading(true));
    const list = fileList.map((el) => ({
      fileName: el.name,
      uploadGuid: guidGenerator(),
      file: el,
    }));
    id && dispatch(createCustomerAttachmentThunk({
      customerId: +id,
      list,
      comment,
      onCancel: () => cancelHandle(),
    }));
  };

  const deleteSelected = () => {
    id && dispatch(deleteMultipleCustomerAttachmentThunk({
      ids: checkedKeys,
      customerId: +id,
      closeModal: () => setDeleteModal(false),
    }));
  };
  return (
    <>
      <CreateAttachmentModal
        isVisible={isCreateModal}
        onCancel={cancelHandle}
        fileList={fileList}
        comment={comment}
        setComment={setComment}
        setFileList={setFileList}
        uploadHandle={uploadHandle}
      />
      <ConfirmationModal
        isVisible={isDeleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        confirmHandler={deleteSelected}
      />
      <CustomerAttachFilters
        filters={filters}
        totalItems={totalCount}
        setCreateModal={setCreateModal}
        setDeleteModal={() => setDeleteModal(true)}
        checkedKeys={checkedKeys}
      />
      <CustomerAttachTable
        attachments={items}
        checkedKeys={checkedKeys}
        isAll={isAll}
        indeterminate={isIndeterminate}
        checkAllHandle={checkAllHandle}
        checkRow={checkRowHandle}
      />
    </>
  );
};

export default CustomerAttachments;
